import * as GSAP from 'gsap';
import AbstractView = require("./abstract/AbstractView");
import YTPlayer = require("../media/YTPlayer");


class KVView extends AbstractView {

    constructor(template: JQuery) {
        super(template);
    }


    onScroll(top: number): void {
        if (this.$introCon) {
            let t: number = this.$introCon.offset().top - (window.innerHeight / 2 + 100);
            if (top > t) {
                this.exploreImage();
            }
        }
    }

    init(): void {
        this.isExplore = false;
        this.createBg();
        // this.createYTVideo();
        this.createTitle();
        this.createExplore();

        GSAP.TweenMax.fromTo(this.$bgProduct, 1, {
            delay: 1,
            y: 50,
            alpha: 0,
        }, {
            delay: 1,
            y: 0,
            alpha: 1,
            ease: GSAP.Circ.easeOut,
            onComplete: function () {

                this.$colorBlock.addClass("kvCycleFilter");
                GSAP.TweenMax.to(this.$colorBlock, 0.5, {
                    alpha: 1,
                });
                this.transitionTitle();

            }.bind(this)
        });
    }

    /*private ytPlayer: YTPlayer;
    private videoBtn: JQuery;

    private createYTVideo(): void {

        this.videoBtn = this.$template.find(".coverBtn");
        this.ytPlayer = new YTPlayer("ytPlayer-loop", "VKfDUfansAA", true, true, false, true);
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.PLAYER_READY, () => {
        });
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.ON_PLAYING, () => {
            this.videoBtn.removeClass("active");
        });
    }*/


    private isTitleShow: boolean;
    private $name: JQuery;
    private $title: JQuery;

    private createTitle(): void {
        this.$name = this.$template.find(".product-name");
        this.$title = this.$template.find(".kv-title");
    }

    private transitionTitle(): void {
        GSAP.TweenMax.fromTo(this.$name, 1, {
                alpha: 0
            },
            {
                alpha: 1,
                ease: GSAP.Linear.easeOut
            });

        this.$title.addClass("active");
    }

    private $bgProduct: JQuery;
    private $colorBlock: JQuery;

    private createBg(): void {
        this.$bgProduct = this.$template.find(".product");
        this.$colorBlock = this.$template.find(".colorBlock");
    }

    private animateData: any[];
    private allSplit: JQuery[];
    private $introCon: JQuery;

    private createExplore(): void {

        this.animateData = [
            {x: -10, y: -30},
            {x: -30, y: -40},
            {x: -50, y: -50},
            {x: -72, y: -60},
            {x: -90, y: -80}
        ];
        this.allSplit = [];
        this.$introCon = this.$template.find(".introCon");

        let splitTotal: number = this.$template.find(".splitImg").length;
        for (let i: number = 0; i < splitTotal; i++) {
            let splitItem: JQuery = this.$template.find(".split-" + (i + 1));
            this.allSplit.push(splitItem);

            GSAP.TweenMax.set(splitItem, {
                x: "-50%",
                y: "-50%",
                alpha: 0
            });
        }
    }

    private isExplore: boolean;

    private exploreImage(): void {

        if (this.isExplore) return;
        this.isExplore = true;

        for (let i: number = 0; i < this.allSplit.length; i++) {
            let splitItem: JQuery = this.allSplit[i];
            let tx: number = this.animateData[i]["x"];
            let ty: number = this.animateData[i]["y"];
            GSAP.TweenMax.to(splitItem, 1, {
                x: tx + "%",
                y: ty + "%",
                alpha: 1,
                ease: GSAP.Circ.easeOut,
                onComplete: function (id: number) {
                    if (id == this.allSplit.length - 1) {
                        let flyItem: JQuery = this.allSplit[1];
                        GSAP.TweenMax.to(flyItem, 0.7, {
                            y: "-55%",
                            ease: GSAP.Circ.easeOut
                        });
                    }
                }.bind(this),
                onCompleteParams: [i]
            });
        }
    }
}

export = KVView;